import { showModal } from 'react-redux-modal-provider';
import DialogTitleDefault from '../default/DialogTitleDefault';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { ButtonBasic } from '../../components';
import { Box, Card, Divider, Grid, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import ModalCrearTicketNubicomMasivos from './ModalCrearTicketNubicomMasivos';
import ModalCrearTicketNubicomV2 from './ModalCrearTicketNubicomV2';

function ModalNewTickets({show, hideModal,onGuardar,permisos}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const handleClose = () => hideModal();
    const onClickTicketNubi = () => {
        showModal(ModalCrearTicketNubicomV2, { onGuardar: onGuardar });
        hideModal()
    }
    const onClickTicketNubiMasivo = () => {
        showModal(ModalCrearTicketNubicomMasivos, { onGuardar: onGuardar });
        hideModal()
    }
    const styleBtn = useMemo(() => ({
        mt:5,
        border:2,
        borderRadius:5,
        borderColor: isDarkMode ? '#64B5F6' : '#0364ff',
        color: isDarkMode ? '#64B5F6' : '#0364ff',
        fontWeight: 'bold',
        width: 180,
        '&:hover':{
            color: isDarkMode ? '#fff' : '#0364ff',
            background: isDarkMode ? '#2d3a52' : '#e6f0ff'
        }
    }), [isDarkMode])
    const styleBtn2 = useMemo(() => ({
        mt:1,
        border:2,
        borderRadius:5,
        borderColor: isDarkMode ? '#64B5F6' : '#0364ff',
        color: isDarkMode ? '#64B5F6' : '#0364ff',
        fontWeight: 'bold',
        width: 180,
        '&:hover':{
            color: isDarkMode ? '#fff' : '#0364ff',
            background: isDarkMode ? '#2d3a52' : '#e6f0ff'
        }
    }), [isDarkMode])
    const styleCard = useMemo(() => ({
        background: isDarkMode ? '#1F2A40' : '#fff',
        display: 'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection: 'column',
        p:3,
        boxShadow:0,
        border:1,
        borderColor: isDarkMode ? '#3d4a62' : '#e0e0e0',
        borderRadius:3,
        minHeight: 270,
        width: 250,
        '&:hover':{
            boxShadow: isDarkMode ? '0 8px 24px rgba(0,0,0,0.4)' : 6
        }
    }), [isDarkMode])
    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='xs' fullWidth className='side'>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}} className='side'>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#2c3e50',fontWeight: 'bold'}} variant='h5'>
                    Nuevo Ticket
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : '#e0e0e0'}} />
                <DialogContent className='side'>
                    <Grid container>
                        <Grid item xs={12} p={1} display='flex' justifyContent='center' alignItems='center'>
                            <Card sx={styleCard}>
                                <img src='/img/nubicom.png' style={{width: 160,height: 55,marginTop:47}} />
                                <ButtonBasic
                                    textButton='Clientes Nubicom'
                                    color='blanco'
                                    variant='wk'
                                    sx={styleBtn}
                                    onClick={()=>onClickTicketNubi()}
                                />
                                <ButtonBasic
                                    textButton='Tickets Masivos'
                                    color='blanco'
                                    variant='wk'
                                    sx={styleBtn2}
                                    onClick={()=>onClickTicketNubiMasivo()}
                                />
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        sx={{width: '80%',mb:1}}
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
}
export default ModalNewTickets;